module.exports = __webpack_public_path__ + "img/hpn.1ebcd7a2.png";